import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const MobileHeader: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);

  const handleLogout = () => {
    if (window.confirm("ログアウトしますか？")) {
      logout();
      navigate("/login");
    }
  };

  return (
    <>
      {/* モバイル専用ヘッダー（768px未満のみ表示） */}
      <header className="md:hidden bg-white border-b border-gray-200 shadow-sm sticky top-0 z-40">
        <div className="flex justify-between items-center px-4 py-3">
          {/* アプリ名 */}
          <Link to="/dashboard" className="no-underline">
            <h1 className="m-0 text-lg font-bold text-transparent bg-clip-text bg-gradient-to-br from-indigo-500 to-purple-600">
              就活ダッシュボード
            </h1>
          </Link>

          {/* プロフィールアイコン */}
          <div className="relative">
            <button
              onClick={() => setShowMenu(!showMenu)}
              className="w-10 h-10 rounded-full overflow-hidden border-2 border-gray-200 bg-transparent p-0 cursor-pointer"
              style={{ minWidth: "44px", minHeight: "44px" }}
            >
              {user?.picture ? (
                <img
                  src={user.picture}
                  alt="プロフィール"
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-semibold text-lg">
                  {user?.username?.charAt(0).toUpperCase() || "U"}
                </div>
              )}
            </button>

            {/* ドロップダウンメニュー */}
            {showMenu && (
              <>
                {/* オーバーレイ（タップで閉じる） */}
                <div
                  className="fixed inset-0 z-40"
                  onClick={() => setShowMenu(false)}
                />

                {/* メニュー本体 */}
                <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 z-50 overflow-hidden">
                  {/* ユーザー情報 */}
                  <div className="p-4 bg-gradient-to-br from-indigo-50 to-purple-50 border-b border-gray-200">
                    <div className="flex items-center gap-3 mb-2">
                      <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-white shadow-sm">
                        {user?.picture ? (
                          <img
                            src={user.picture}
                            alt="プロフィール"
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="w-full h-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-semibold text-lg">
                            {user?.username?.charAt(0).toUpperCase() || "U"}
                          </div>
                        )}
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-semibold text-gray-800 m-0 truncate">
                          {user?.username || "ユーザー"}
                        </p>
                        <p className="text-xs text-gray-600 m-0 truncate">
                          {user?.email || ""}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* 管理者リンク（管理者のみ） */}
                  {user?.role === "admin" && (
                    <Link
                      to="/admin"
                      className="flex items-center gap-3 px-4 py-3 text-purple-600 hover:bg-purple-50 transition-colors no-underline border-b border-gray-100"
                      onClick={() => setShowMenu(false)}
                    >
                      <span className="font-medium">管理者ページ</span>
                    </Link>
                  )}

                  {/* ログアウトボタン */}
                  <button
                    onClick={handleLogout}
                    className="w-full flex items-center justify-center px-4 py-3 text-red-600 hover:bg-red-50 transition-colors bg-transparent border-none cursor-pointer font-medium"
                    style={{ minHeight: "44px" }}
                  >
                    ログアウト
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default MobileHeader;
